// extracted by mini-css-extract-plugin
export default {"infoAlert":"CreateBulkEmail-CreateBulkEmail__infoAlert--d9x7R","contentBox":"CreateBulkEmail-CreateBulkEmail__contentBox--N_nkx"};